
















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { Directory } from "../../../../domain/drawing";
import { FormatReference } from "../../../../domain/format";
import { ModelEditableMixin } from "../../../system/mixins";

@Component
export default class FormatSelectView extends Mixins(ModelEditableMixin) {
  @Prop()
  rootFolderId: string;

  @Prop()
  folderId: string;

  @Prop()
  loadWizardTemplates: (key: string) => Promise<Directory<string, FormatReference>[]>;

  data(): any {
    return {
      isLoading: false,
      root: null as Directory<string, FormatReference>,
      currentFolder: null as Directory<string, FormatReference>,
      selectedFormat: null as FormatReference,
    };
  }
  isLoading: boolean;
  root: Directory<string, FormatReference>;
  currentFolder: Directory<string, FormatReference>;
  selectedFormat: FormatReference;

  get formats(): FormatReference[] {
    return (this.currentFolder && this.currentFolder.entities)
      ? this.currentFolder.entities
      : [];
  }

  get folders(): Directory<string, FormatReference>[] {
    return (this.currentFolder && this.currentFolder.nodes)
      ? this.currentFolder.nodes
      : [];
  }

  get isCurrentFolderRoot(): boolean {
    return this.currentFolder === this.root;
  }

  get currentFolderName(): string {
    return this.currentFolder ? this.currentFolder.name : "";
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  created() {
    this.loadFolders();
  }

  private async loadFolders(): Promise<void> {
    try {
      this.isLoading = true;
      this.root = await this.getRootFolder();
      if (!this.folderId) {
        this.currentFolder = this.root;
      } else {
        const found = Enumerable.from(this.root.nodes)
          .selectMany(f => [ f ].concat(f.nodes))
          .firstOrDefault(f => f.key === this.folderId);
        this.currentFolder = found ? found : this.root;
      }
    } catch (e) {
        this.$error(
          this.formatNameWording + "情報取得失敗",
          this.formatNameWording + "情報を取得できませんでした。",
          e,
        );
    } finally {
      this.isLoading = false;
    }
  }

  private async getRootFolder(): Promise<Directory<string, FormatReference>> {
    const root = new Directory<string, FormatReference>(
      null,
      "",
      await this.loadWizards("guest"),
      []
    );
    if (this.rootFolderId) {  // rootFolderIdが指定されてる場合は該当するフォルダを探す.なければroot.
      const found = Enumerable.from(root.nodes)
        .selectMany(f => [ f ].concat(f.nodes))
        .firstOrDefault(f => f.key === this.rootFolderId);
      return found ? found : root;
    } else {                  // rootFolderIdが指定されてない場合は有効なフォルダ(フォーマットがあるフォルダ)を探す.複数あればroot.
      const validFolders = Enumerable.from(root.nodes)
        .selectMany(f => [ f ].concat(f.nodes))
        .where(f => f.entities && (0 < f.entities.length))
        .toArray();
      return (validFolders.length === 1) ? validFolders[0] : root;
    }
  }

  private async loadWizards(key: string): Promise<Directory<string, FormatReference>[]> {
    return this.loadWizardTemplates
        ? this.loadWizardTemplates(key)
        : DomainRegistry.format.getFormatRepository().getWizards(key);
  }

  selectFormat(source: FormatReference): void {
    this.editingSource = source;
  }

  selectFolder(source: Directory<string, FormatReference>): void {
    this.currentFolder = source;
  }

  selectParentFolder(): void {
    if (this.currentFolder !== this.root) {
      const found = this.findParentFolder(this.currentFolder, this.root);
      if (found !== null) {
        this.currentFolder = found;
      }
    }
  }

  private findParentFolder(target: Directory<string, FormatReference>, root: Directory<string, FormatReference>): Directory<string, FormatReference> {
    return Enumerable.from(root.nodes).any(n => n === target)
      ? root
      : Enumerable.from(root.nodes).select(n => this.findParentFolder(target, n)).firstOrDefault(n => !!n);
  }
}
